import { render, staticRenderFns } from "./IssueDocumentOverview.vue?vue&type=template&id=5ef393ec"
import script from "./IssueDocumentOverview.vue?vue&type=script&lang=ts"
export * from "./IssueDocumentOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports